<template>
  <div>
	  <div class="cs-loader">
	  </div>

    <div class="intro" id="intro">
	    <svg version="1.1" id="logo_svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 width="285px" height="285px" viewBox="0 0 285 285" enable-background="new 0 0 285 285" xml:space="preserve">
				<path style="fill: #000;stroke: #FFF" d="M26.775,52.784 120.971,198.604 135.654,175.789 72.082,77.48 239.83,77.48 255.714,52.784 z"/>
				<path  style="fill: #000;stroke: #FFF" d="M108.85,112.983 187.617,112.983 126.569,207.873 141.258,230.696 232.876,88.287 92.96,88.287 z"/>
		</svg>
    </div>
    <div class="video">
    	<div class="mask clip-svg">
	   	 <video preload="none" muted="true" loop id="video_vinzi">
	   	 	<source src="../assets/background-vinzi.mp4" type="video/mp4">
	   	 	<source src="../assets/background-vinzi.webm" type="video/webm">
	   	 </video>
	   	 <div class="overlay">
	   	 	<div class="text">
	   	 		<h1><b>VINZI</b>STUDIO</h1>

	   	 			<svg class="svg_subtitle" height="100%" width="100%">
					    <defs>
					        <mask id="svgTextPath">
					        	<rect x="0" y="0" width="100%" height="100%" fill="#ffffff"/>

					            <text font-family="Barlow Semi Condensed" font-size="1.8em" font-weight="600" x="20" y="26" dy="1"> AGENCE DE PRODUCTION AUDIOVISUELLE </text>
					        </mask>
					    </defs>
					    <rect x="0" y="0" width="100%" height="100%"  fill="#ffffff" mask="url(#svgTextPath)"/> 
					</svg>
					<h2>ENTREZ DANS NOTRE UNIVERS
					<a v-on:click="goTo('galerie')" ><img class="animated infinite pulse cp" src="../assets/go_to_bottom.png" alt=""></a>
					</h2>
	   	 	</div>
	   	 </div>
	    </div>	
    </div>
    <Project v-for="projet in projets" :projectObj="projet"></Project>
   <Menu></Menu>	
   <References></References>	
   <Footer></Footer>
  </div>
</template>

<script>
import {TweenLite, TimelineLite} from 'gsap'
import Vivus from 'vivus'
import Project from './Project'
import Menu from './Menu'
import Footer from './Footer'
import References from './References'
import $ from 'jquery'

export default {
  name: 'Intro',
  components: { Project, Menu, References, Footer },
  data () {
    return {
      section_intro: document.getElementById('intro'),
  	  tween: TweenLite,
  	  projets: []

    }
  },
  methods: {
  	init () {
  		var that = this
  		var tl = new TimelineLite({
	  	  		onComplete: function () {
		  				that.enableScrolling()
		  		}
		  })
  		tl.stop()
  		tl.to('#intro', 1.5, { opacity: 0 })
  		tl.to('#intro', 0.1, { "display": "none" })
  		tl.to('.clip-svg', 1.5, { '-webkit-mask-size': "800%", 'mask-size': "800%"}, '+=.8')
  		tl.to('.clip-svg', .01, { '-webkit-mask-position': "50% 34%", 'mask-position': "50% 34%"}, '-=1.5')
  		tl.to('.clip-svg', 0.1, { '-webkit-mask': "none" })
  		tl.from('.text h1', .5, { 'margin-left': "-500px" }, '-=.5').to('.text h1', 1, { 'margin-left': "0px" })
  		tl.from('.text .svg_subtitle', .5, { 'margin-left': "-1500px" }, '-=1.3')
  				.to('.text .svg_subtitle', 1, { 'margin-left': "0px" }, '+=0.5')
  		tl.from('.text h2', .5, { 'margin-left': "-1500px" }, '-=2')
  				.to('.text h2', 1, { 'margin-left': "0px" })
  		
  		setTimeout(function () {
  			$('.cs-loader').remove()
	  		new Vivus('logo_svg', {duration: 180, type: "sync"}, function() {
		  		tl.play()
		  		document.getElementById('video_vinzi').play()
  				that.retrieveDatas()
	  		});		
  		}, 1500)



  		
  	},
  	disableScrolling(){
	    var x=0;
	    var y=0;
	    window.onscroll=function(){window.scrollTo(x, y);};
	},
	enableScrolling(){
	    window.onscroll=function(){};
	},
  	goTo(page) {
  		var offset = 0
  		if (page == 'galerie') { offset = $(window).height() }
  		$('html, body').animate({
			scrollTop: offset
		}, 'slow');
  	},
  	retrieveDatas () {
  		var self = this
  		$.ajax({
            url: '/retrieve-projets',
            method: 'GET',
            success: function (data) {
            	console.log(data)
                self.projets = data;
            },
            error: function (error) {
                console.log(error);
            }
        });
  	}
  },
  mounted: function () {
  	this.disableScrolling()
  	this.init()
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

body {
  background: #000;
  color: #FFF;
}

.cs-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: #000;
  z-index: 99999999;
}

.intro {
  position: absolute;
  background: #000;
	top: 50%;
	left: 50%;
	transform: translateY(-50%) translateX(-50%);
    width: 100%;
    height: 100%;
  z-index: 200;
  opacity: 1;
  text-align: center;
}
#logo_svg {
	position: absolute;
	top: 50%;
	transform: translateY(-50%)  translateX(-50%);
}
.video {
  position: relative;
  background: #000;
  height: 100vh;
  width: 100%;
  z-index: 1;
  overflow: hidden;
}

.mask {
	height: 100%;
	width: 100%;
}
.clip-svg {
  	/*clip-path: url('#myClip');*/
  	mask-image: url('../assets/logo.svg');
  	mask-position: center;
  	mask-repeat: no-repeat;
  	mask-size: 285px;
}


.video video {
	position: absolute;
	top: 0;
	left:50%; right: 50%; bottom: 0;
	 min-width: 100%; min-height: 100%;
	  width: auto; height: auto; z-index: -100;
	  background-size: cover;
		transform: translateX(-50%);
	transform-origin: 50%;
}

.overlay {
	height: 100%;
	width: 100%;
	color: #fff;
	position: relative;
}
.overlay .text {
	position: absolute;
	bottom: 100px;
	left: 100px;
	width: 100%;
}
.overlay h1 b {
	font-weight: 900;
}
.overlay h1  {
	font-size: 3.5em;
	font-weight: 400;
}

.overlay h2  {
	font-size: 1.2em;
	font-weight: 400;
	margin-top: 10px; 
}

.overlay h2  img { 
	margin:5px 0 0 15px;
}

.svg_subtitle { 
	max-width: 515px; 
	max-height: 35px;
}

.cp { cursor: pointer; }

@media screen and (max-width: 640px) { 

	.overlay .text {
		position: absolute;
		bottom: 100px;
		left: 0;
		text-align: center;
		width: 100%;
	}
	
	.svg_subtitle { 
		max-width: 400px; 
		max-height: 35px;
	}

	#svgTextPath text {
		font-size: 1.3em;
	}


}

@media only screen and (max-device-width: 812px) {
	
	#video_vinzi {display: none;}
	
	.video {
		background: url('../assets/mobile-bg.jpg') no-repeat top center;
		background-size: cover;
	}
	
}

</style>



// WEBPACK FOOTER //
// src/components/Intro.vue